import { render, staticRenderFns } from "./prohibitedClass.vue?vue&type=template&id=44d73ad2&scoped=true"
import script from "./prohibitedClass.vue?vue&type=script&lang=js"
export * from "./prohibitedClass.vue?vue&type=script&lang=js"
import style0 from "./prohibitedClass.vue?vue&type=style&index=0&id=44d73ad2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d73ad2",
  null
  
)

export default component.exports